import { ICreateChangeBase } from '@fi-shared/models/models';

export interface IAgreementPublishedContentModel extends ICreateChangeBase {
    Id: number;
    AgreementId: number;
    ContentLanguageId: number;
    AgreementVersion: number;
    Content: string;
    ContentHash: string;
    IsPublished: boolean;
}

export class AgreementPublishedContentModel {
    Id: number;
    AgreementId: number;
    ContentLanguageId: number;
    AgreementVersion: any;
    Content: string;
    ContentHash: string;
    IsPublished: boolean;
    CreatedByUserId: number;
    CreatedOn: any;
    ChangedByUserId: number;
    ChangedOn: any;
    CreatedByUserName: string;
    ChangedByUserName: string;

    constructor(data?: IAgreementPublishedContentModel) {
        data = data || ({} as IAgreementPublishedContentModel);
        this.Id = data.Id;
        this.AgreementId = data.AgreementId;
        this.ContentLanguageId = data.ContentLanguageId;
        this.AgreementVersion = data.AgreementVersion;
        this.Content = data.Content;
        this.ContentHash = data.ContentHash;
        this.IsPublished = data.IsPublished || false;
        this.CreatedByUserId = data.CreatedByUserId;
        this.CreatedOn = data.CreatedOn;
        this.ChangedByUserId = data.ChangedByUserId;
        this.ChangedOn = data.ChangedOn;
        this.CreatedByUserName = data.CreatedByUserName;
        this.ChangedByUserName = data.ChangedByUserName;
    }
}
